
let ua = navigator.userAgent
let ua_lc  = ua.toLowerCase()
var url = new URL(window.location.href);

let mobile =  /(iphone|ipad|ipod|android)/i.test(ua_lc)
let ios = (/(ios|ipad|iphone|ipod)/gi).test(ua_lc)
let android =  /android/.test(ua_lc)

let messenger = /fban\/messengerforios/.test(ua_lc) || /fb_iab\/messenger/.test(ua_lc)

var facebook_video_ad_urlparam = (window.location.href.indexOf("fbvideo")> -1);

let el_vh = document.createElement("div")
el_vh.style.cssText= `position: absolute;
                      pointer-events:none;
                      top:0px;
                      width:1px;
                      height:100vh;`
document.body.appendChild(el_vh)
let facebook_video_ad = (ios)  ? (facebook_video_ad_urlparam && (window.screen.height - el_vh.clientHeight < 30))
                          : (facebook_video_ad_urlparam && (window.screen.height - window.innerHeight) < 30);
document.body.removeChild(el_vh)

export default  {
  mobile: mobile,
  ios: ios,
  android:  android ,

  facebook_video_ad:facebook_video_ad,
  facebook: /(fban|fbav)/i.test(ua_lc) && !messenger && !facebook_video_ad,
  messenger: messenger,
  instagram: /instagram/.test(ua_lc),

  wechat : /micromessenger/i.test(ua_lc),
  weibo : /weibo/.test(ua_lc),
  ucbrowser : /ucbrowser/.test(ua_lc),
  samsung : (/samsung/).test(ua_lc),

  ios_safari:  (ios && !(/(crios|fxios|opios|mercury|ucbrowser|fbav|fban|instagram)/).test(ua_lc)),
  ios_chrome:   ios && /crios/.test(ua_lc),

  android_chrome:  (android && /chrome/.test(ua_lc) && !(/(opr|opera|ucbrowser|samsung|fbav|fban|instagram)/gi).test(ua_lc)) && !messenger,
}